module.exports = __webpack_public_path__ + "img/tile-rendering_en.0b53bb9.jpg";